import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials = true makes the browser include the httpOnly auth cookie
// (set by the backend on /auth/login & /auth/register). No tokens are read or
// written from JavaScript, so they're not exposed to XSS.
const api = axios.create({ baseURL: API, withCredentials: true });

let onUnauthorized = null;
export const setUnauthorizedHandler = (fn) => {
  onUnauthorized = fn;
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && onUnauthorized) {
      const detail = err?.response?.data?.detail || "Session expired";
      onUnauthorized(detail);
    }
    return Promise.reject(err);
  },
);

export default api;
